import { NEW_USER as $ST } from 'plugins/tfs/platformConfigs/staticTextMaps/auth';
import $R from 'plugins/tfs/platformConfigs/integrationMaps/routes';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { sendForm, hideModalAction } from 'actions/signup';
import TextBox from 'theme/TextBox';
import Checkbox from 'theme/CheckBox';
import Error from 'theme/Error';
import { DatePicker } from 'antd';
import Form from 'theme/Form';
import Modal from 'theme/Modal';
import Widget from 'theme/widgets';
import SmsVerificationModal from 'components/partials/SmsVerificationModal';
import moment from 'moment';

import './style.less';

const dateFormatList = ['YYYY-MM-DD', 'DD-MM-YYYY', 'DD/MM/YYYY', 'DD/MM/YY'];
const isDateOfBirthInputActive = false;

class NewUser extends Form {
  constructor(props) {
    super(props);
    this.state = {
      formData: {},
      validationErrors: {},
      modals: {
        allowed: false,
        userAgreement: false,
        permission: false,
        privacyPolicy: false,
      },
    };
    this.submitForm = this.submitForm.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.initFormData({
      first_name: '',
      last_name: '',
      phone: '',
      email: '',
      date_of_birth: '',
      password: '',
      is_allowed: false,
      permissions: false,
      confirm: false,
    });
  }

  openModal(modalName) {
    this.setState({
      modals: {
        [modalName]: true,
      },
    });
  }

  closeModal() {
    this.setState({
      modals: {},
    });
  }

  submitForm(event) {
    event.preventDefault();
    const { dispatch } = this.props;
    const { email } = this.state.formData;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email)) {
      this.setState({ validationErrors: { email: $ST.INVALID_EMAIL } });
      return;
    }
    dispatch(
      sendForm({
        ...this.state.formData,
      })
    );
  }

  render() {
    const { pending, status, smsModalVisibility, error, dispatch } = this.props;
    const { formData, modals } = this.state;

    if (status === 201) {
      return <Redirect to={$R.MAIN_HOME.path} />;
    }

    return (
      <div className='container signup-form login_form-container headerMargin'>
        {smsModalVisibility && (
          <Modal onClose={() => dispatch(hideModalAction())} width={70}>
            <SmsVerificationModal
              error={error}
              onEnter={(verification_code) => {
                this.setState(
                  {
                    formData: {
                      ...this.state.formData,
                      code: verification_code,
                    },
                  },
                  () => dispatch(sendForm(this.state.formData))
                );
              }}
            />
          </Modal>
        )}

        {modals.allowed && (
          <Modal onClose={this.closeModal}>
            <div className='modal-text'>
              <Widget path='user.message_permission' />
            </div>
          </Modal>
        )}

        {modals.permission && (
          <Modal onClose={this.closeModal}>
            <div className='modal-text'>
              <Widget path='user.consent_text' />
            </div>
          </Modal>
        )}
        {modals.userAgreement && (
          <Modal onClose={this.closeModal}>
            <div className='modal-text'>
              <Widget path='user.user_agreement' />
            </div>
          </Modal>
        )}
        {modals.privacyPolicy && (
          <Modal onClose={this.closeModal}>
            <div className='modal-text'>
              <Widget path='user.privacy_policy' />
            </div>
          </Modal>
        )}
        <div className='row'>
          <div className='col-12 col-lg-6 offset-lg-3'>
            <form onSubmit={this.submitForm}>
              <div className='row'>
                <div className='col-12'>
                  <h3 className='form-title-hero'>{$ST.CREATE_NEW_USER}</h3>
                </div>
                <div className='col-12'>
                  <div className='input-margin'>
                    <p className='form-label-title'>{$ST.NAME}</p>
                    <TextBox
                      name='first_name'
                      type='text'
                      placeholder={$ST.PLACEHOLDER.NAME}
                      onChange={(value) => this.setField('first_name', value)}
                      value={formData.first_name}
                    />
                    <Error data={error} field='first_name' />
                  </div>
                  <div className='input-margin'>
                    <p className='form-label-title'>{$ST.SURNAME}</p>
                    <TextBox
                      name='last_name'
                      type='text'
                      placeholder={$ST.PLACEHOLDER.SURNAME}
                      onChange={(value) => this.setField('last_name', value)}
                      value={this.state.formData.last_name}
                    />
                    <Error data={error} field='last_name' />
                  </div>
                  {isDateOfBirthInputActive && (
                    <div className='input-margin'>
                      <p className='form-label-title'>{$ST.BIRTH_DATE}</p>
                      <DatePicker
                        name='date_of_birth'
                        value={
                          formData.date_of_birth
                            ? moment(formData.date_of_birth, dateFormatList[0])
                            : ''
                        }
                        className='textbox'
                        placeholder='2000-12-30'
                        onChange={(date, stringDate) =>
                          this.setField('date_of_birth', stringDate)
                        }
                        format={dateFormatList[0]}
                      />
                      <Error data={error} field='date_of_birth' />
                    </div>
                  )}
                  <div className='input-margin'>
                    <p className='form-label-title'>{$ST.PHONE_NUMBER}</p>
                    {this.state.formData.phone && (
                      <span className='prefix'>+</span>
                    )}
                    <TextBox
                      type='tel'
                      classes='symbol'
                      masked
                      placeholder={$ST.PLACEHOLDER.PHONE_NUMBER}
                      mask={[
                        '0',
                        '0',
                        '3',
                        '2',
                        ' ',
                        /[0-9]/,
                        /[0-9]/,
                        /[0-9]/,
                        /[0-9]/,
                        /[0-9]/,
                        /[0-9]/,
                        /[0-9]/,
                        /[0-9]/,
                        /[0-9]/,
                      ]}
                      name='phone'
                      onChange={(value) => this.setField('phone', value)}
                      value={this.state.formData.phone}
                    />
                    <Error data={error} field='phone' />
                  </div>
                  <div className='input-margin'>
                    <p className='form-label-title'>{$ST.EMAIL}</p>
                    <TextBox
                      name='email'
                      type='text'
                      placeholder={$ST.PLACEHOLDER.EMAIL_ADDRESS}
                      onChange={(value) => {
                        this.setField('email', value);
                        this.setState({ validationErrors: {} });
                      }}
                      value={this.state.formData.email}
                    />
                    <Error message={this.state.validationErrors.email} data={error} field='email' />
                  </div>
                  <div className='input-margin'>
                    <p className='form-label-title'>{$ST.PASSWORD}</p>
                    <TextBox
                      name='password'
                      type='password'
                      placeholder={$ST.PLACEHOLDER.PASSWORD}
                      onChange={(value) => this.setField('password', value)}
                      value={this.state.formData.password}
                    />
                    <Error data={error} field='password' />
                  </div>
                </div>
                <div className='col-12 checkboxes'>
                  <div className='checkboxes-margin'>
                    <Checkbox
                      name='confirm'
                      value={$ST.USER_AGREEMENT.CHECKBOX_VALUE}
                      icon='check'
                      checked={formData.confirm}
                      onChange={(checked) => this.setField('confirm', checked)}
                    >
                      <div className='checkbox-text'>
                        {` ${$ST.READ_AND_AGREE}`}{' '}
                        <a
                          onClick={() => this.openModal('userAgreement')}
                          className='link agreement-link'
                        >
                          {$ST.USER_AGREEMENT.PART1}
                        </a>
                        {` ${$ST.USER_AGREEMENT.PART2} `}
                        <a
                          onClick={() => this.openModal('privacyPolicy')}
                          className='link agreement-link'
                        >
                          {` ${$ST.PRIVACY_POLICY} `}
                        </a>
                      </div>
                    </Checkbox>
                  </div>
                  {$ST.ELECTRONIC_MESSAGE_CONFIRM.VISIBLE && (
                    <div className='checkboxes-margin'>
                      <Checkbox
                        name='is_allowed'
                        value={$ST.ELECTRONIC_MESSAGE_CONFIRM.CHECKBOX_VALUE}
                        icon='check'
                        checked={formData.is_allowed}
                        onChange={(checked) =>
                          this.setField('is_allowed', checked)
                        }
                      >
                        <div className='checkbox-text'>
                          <a
                            onClick={() => this.openModal('allowed')}
                            className='link'
                          >
                            {$ST.ELECTRONIC_MESSAGE_CONFIRM.VALUE}
                          </a>
                        </div>
                      </Checkbox>
                    </div>
                  )}
                  {$ST.PRIVACY_SECURITY.VISIBLE && (
                    <div className='checkboxes-margin'>
                      <Checkbox
                        name='permissions'
                        value={`${$ST.PRIVACY_SECURITY.LABEL} ${$ST.READ_AND_AGREE}`}
                        icon='check'
                        checked={formData.permissions}
                        onChange={(checked) =>
                          this.setField('permissions', checked)
                        }
                      >
                        <div className='checkbox-text'>
                          {$ST.READ_AND_AGREE}{' '}
                          <a
                            onClick={() => this.openModal('permission')}
                            className='link'
                          >
                            {$ST.CONSENT_TEXT}.
                          </a>
                        </div>
                      </Checkbox>
                      <Error data={error} field='confirm' />
                    </div>
                  )}
                  <div className='checkboxes-margin'>
                    <button
                      type='submit'
                      className='button float-left pointer'
                      disabled={pending}
                    >
                      {$ST.SAVE}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    smsModalVisibility: state.signup.smsModalVisibility,
    status: state.signup.status,
    pending: state.signup.pending,
    error: state.signup.error,
  };
};

export default connect(mapStateToProps)(NewUser);



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/auth/index.js